<p-dialog 
  [header]="headerTitle | translate"
  [(visible)]="displayModal" 
  [style]="{width: modalWidth}" 
  [modal]="true" 
  [draggable]="false"
  [closable]="true"
  (onHide)="onFecharModal()">
  
  <!-- Filtro de busca -->
  <div class="mb-3">
    <input 
      type="text" 
      class="form-control filtro-input" 
      [placeholder]="filterPlaceholder | translate"
      [(ngModel)]="filtroTexto">
  </div>
  
  <!-- Grid de dealers -->
  <div class="dealers-grid" *ngIf="dealersFiltrados.length > 0">
    <ng-container *ngFor="let dealer of dealersFiltrados">
      <span 
        class="btn btn-primary btn-sm dealer-item" 
        (click)="onSelecionarDealer(dealer)"
        [attr.title]="getHintText(dealer) ? null : dealer.toTexto()"
        [pTooltip]="getHintText(dealer)"
        [tooltipZIndex]="getHintText(dealer) ? '10001' : 'auto'"
        [tooltipStyleClass]="getHintText(dealer) ? 'filtro-dealers-hint' : ''"
        tooltipPosition="top">
        {{dealer.toTexto()}}
      </span>
    </ng-container>
  </div>
  
  <!-- Mensagem quando não há dealers -->
  <div class="no-dealers-message" *ngIf="dealersFiltrados.length === 0">
    <p class="text-muted text-center">
      {{ 'relatorioVeiculos.controlePedidos.nenhumRegistroExibir' | translate }}
    </p>
  </div>
  
</p-dialog>
